import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const LegalLayout = ({ title, children }) => (
  <div className="min-h-screen bg-[#FDFBF7] text-[#1A1A1A]">
    <div className="mx-auto max-w-3xl px-6 py-16">
      <Link to="/" className="mb-8 inline-flex items-center gap-2 text-sm text-[#5C5A55] hover:text-[#C5A059]">
        <ArrowLeft size={16} /> Zpět na hlavní stránku
      </Link>
      <h1 className="mb-10 font-heading text-4xl">{title}</h1>
      <div className="space-y-6 leading-relaxed text-[#3a3a38]">{children}</div>
    </div>
  </div>
);

export default function Cookies() {
  return (
    <LegalLayout title="Zásady používání cookies">
      <p>Tyto zásady vysvětlují, jak web Svatební světy používá soubory cookies a podobné technologie.</p>
      <h2 className="font-heading text-2xl">Co jsou cookies</h2>
      <p>Cookies jsou malé textové soubory ukládané do vašeho prohlížeče. Pomáhají nám zajistit správné fungování webu a zlepšovat vaše uživatelské prostředí.</p>
      <h2 className="font-heading text-2xl">Jaké cookies používáme</h2>
      <p><strong>Nezbytné cookies</strong> – zajišťují základní funkce webu (např. uložení souhlasu s cookies, přihlášení do administrace). Tyto cookies nelze vypnout.</p>
      <p><strong>Preferenční cookies</strong> – umožňují zapamatovat si vaše volby (např. jazyk či nastavení zobrazení).</p>
      <p>Nepoužíváme žádné marketingové ani sledovací cookies třetích stran.</p>
      <h2 className="font-heading text-2xl">Správa cookies</h2>
      <p>Souhlas s cookies můžete kdykoli změnit vymazáním dat webu ve vašem prohlížeči. Cookies lze rovněž blokovat v nastavení prohlížeče.</p>
      <h2 className="font-heading text-2xl">Kontakt</h2>
      <p>V případě dotazů nás kontaktujte na 4uweb-sluzby@seznam.cz.</p>
      <p className="text-sm text-[#5C5A55]">Poslední aktualizace: červen 2026</p>
    </LegalLayout>
  );
}
